import { DefaultState } from 'store/reducers/types';

export const READ_ASSOCIATES_DATA_REQUEST = 'READ_ASSOCIATES_DATA_REQUEST';
export const READ_ASSOCIATES_DATA_SUCCESS = 'READ_ASSOCIATES_DATA_SUCCESS';
export const READ_ASSOCIATES_DATA_FAILURE = 'READ_ASSOCIATES_DATA_FAILURE';

export type AssociatesData = {
  fullName: string;
  id: number;
  lastLogin: string;
  metro: string;
  onboardingInitiated: string;
  onboardingStatus: string;
  systemStatus: string;
};

export type AssociatesState = DefaultState & {
  contents?: AssociatesData;
};

interface ReadAssociatesDataRequest {
  type: typeof READ_ASSOCIATES_DATA_REQUEST;
};

interface ReadAssociatesDataSuccess {
  type: typeof READ_ASSOCIATES_DATA_SUCCESS,
  contents: AssociatesData;
}

interface ReadAssociatesDataFailure {
  type: typeof READ_ASSOCIATES_DATA_FAILURE;
}

export type AssociatesActionTypes = ReadAssociatesDataRequest | ReadAssociatesDataSuccess | ReadAssociatesDataFailure;